module.exports = __webpack_public_path__ + "static/servicegrid2-794036fcdcc359903f4cc6db44f07514.png";